import React, { useEffect, useRef } from "react";

export const PayPalButton = ({
	amount = "10.00",
	currency = "GBP",
	clientId,
	paymentMethods,
	setPaymentMethods,
	onError: onErrorProp,
	onCancel: onCancelProp,
}) => {
	const paypalRef = useRef(null);

	useEffect(() => {
		if (!paypalRef.current || !clientId) return;

		const loadPayPalScript = () => {
			// Check if PayPal script is already loaded
			if (window.paypal) {
				renderButton();
				return;
			}

			const script = document.createElement("script");
			script.src = `https://www.paypal.com/sdk/js?client-id=${clientId}&currency=${currency}&intent=capture`;
			script.async = true;
			script.onload = renderButton;
			script.onerror = () => console.error("Failed to load PayPal script");
			document.head.appendChild(script);
		};

		const renderButton = () => {
			// Clear any existing buttons
			paypalRef.current.innerHTML = "";

			window.paypal
				.Buttons({
					style: {
						layout: "horizontal",
						color: "black",
						shape: "rect",
						label: "donate",
						tagline: false,
					},
					createOrder: (data, actions) => {
						return actions.order.create({
							purchase_units: [
								{
									amount: {
										value: amount.toString(),
										currency_code: currency,
									},
								},
							],
							application_context: {
								shipping_preference: "NO_SHIPPING",
							},
						});
					},
					onApprove: async (data, actions) => {
						try {
							const capture = await actions.order.capture();
							const captureId =
								capture?.purchase_units?.[0]?.payments?.captures?.[0]?.id ||
								null;
							paymentMethods.forEach((method) => {
								if (method.type === "paypal") {
									method.success = true;
									method.paypal_invoice_number = data.orderID;
									method.paypal_transaction_id = captureId;
								}
							});
							setPaymentMethods([...paymentMethods]);
							return capture;
						} catch (error) {
							console.error("PayPal capture error:", error);
						}
					},
					onError: (err) => {
						console.error("PayPal error:", err);
						if (typeof onErrorProp === "function") {
							onErrorProp(err);
						}
					},
					onCancel: (data) => {
						console.log("PayPal payment cancelled:", data);
						if (typeof onCancelProp === "function") {
							onCancelProp(data);
						}
					},
				})
				.render(paypalRef.current);
		};

		loadPayPalScript();
	}, [amount, currency, clientId]);

	return (
		<div
			ref={paypalRef}
			className="paypal-button-container"
			style={{
				minWidth: "200px",
				minHeight: "45px",
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
			}}
		/>
	);
};

// import React, { useEffect, useRef } from "react";

// export const PayPalButton = ({ selectedPaymentMethod, config, onClick }) => {
// 	const paypalRef = useRef(null);

// 	useEffect(() => {
// 		const renderPayPalButton = async () => {
// 			if (!paypalRef.current || !config.paypal_client_id) return;

// 			try {
// 				// Get the amount from selectedPaymentMethod or config
// 				const amount =
// 					selectedPaymentMethod?.amount || config.amount || "10.00";
// 				const currency = config.currency || "GBP";

// 				// Initialize PayPal and get the buttons configuration
// 				const buttonsConfig = await initializePaypal(
// 					config.paypal_client_id,
// 					amount,
// 					currency
// 				);

// 				// Clear any existing PayPal buttons
// 				paypalRef.current.innerHTML = "";

// 				// Render the PayPal button
// 				window.paypal
// 					.Buttons({
// 						...buttonsConfig,
// 						onApprove: async (data, actions) => {
// 							try {
// 								const authorization = await actions.order.authorize();
// 								console.log("PayPal authorization:", authorization);

// 								// Call your onClick handler with the authorization data
// 								if (onClick) {
// 									onClick({
// 										type: "paypal",
// 										authorization,
// 										orderID: data.orderID,
// 									});
// 								}

// 								return authorization;
// 							} catch (error) {
// 								console.error("PayPal authorization error:", error);
// 							}
// 						},
// 						onError: (err) => {
// 							console.error("PayPal error:", err);
// 						},
// 						onCancel: (data) => {
// 							console.log("PayPal payment cancelled:", data);
// 						},
// 					})
// 					.render(paypalRef.current);
// 			} catch (error) {
// 				console.error("Failed to render PayPal button:", error);
// 			}
// 		};

// 		renderPayPalButton();
// 	}, [selectedPaymentMethod, config, onClick]);

// 	return (
// 		<div
// 			ref={paypalRef}
// 			className="paypal-button-container"
// 			style={{
// 				minWidth: "200px",
// 				minHeight: "45px",
// 				display: "flex",
// 				justifyContent: "center",
// 				alignItems: "center",
// 			}}
// 		/>
// 	);
// };

// // Your existing initializePaypal function (updated)
// export const initializePaypal = async (
// 	paypalClientId,
// 	amount,
// 	currency = "GBP"
// ) => {
// 	return new Promise((resolve, reject) => {
// 		// Check if PayPal script is already loaded
// 		if (window.paypal) {
// 			const buttonsConfig = createPaypalButtonsConfig(amount, currency);
// 			resolve(buttonsConfig);
// 			return;
// 		}

// 		const script = document.createElement("script");
// 		script.src = `https://www.paypal.com/sdk/js?client-id=${paypalClientId}&currency=${currency}&intent=authorize`;
// 		script.async = true;

// 		script.onload = () => {
// 			// Create and return the PayPal buttons configuration
// 			const buttonsConfig = createPaypalButtonsConfig(amount, currency);
// 			resolve(buttonsConfig);
// 		};

// 		script.onerror = () => {
// 			reject(new Error("Failed to load PayPal script"));
// 		};

// 		document.head.appendChild(script);
// 	});
// };

// // Helper function to create PayPal buttons configuration
// const createPaypalButtonsConfig = (amount, currency) => {
// 	return {
// 		style: {
// 			layout: "horizontal",
// 			color: "black",
// 			shape: "rect",
// 			label: "donate",
// 		},
// 		createOrder: (data, actions) => {
// 			return actions.order.create({
// 				purchase_units: [
// 					{
// 						amount: {
// 							value: amount.toString(),
// 							currency_code: currency,
// 						},
// 					},
// 				],
// 			});
// 		},
// 		onApprove: (data, actions) => {
// 			return actions.order.authorize().then((authorization) => {
// 				console.log("PayPal authorization:", authorization);
// 				return authorization;
// 			});
// 		},
// 		onError: (err) => {
// 			console.error("PayPal error:", err);
// 		},
// 		onCancel: (data) => {
// 			console.log("PayPal payment cancelled:", data);
// 		},
// 	};
// };
